/**
 *
 * @module platformProfileReference
 *
 */

/**
 *
 * @access private
 * @typedef SDK.Services.Configuration.PlatformProfileReference
 * @type {Object}
 * @since 3.7.0
 * @desc Internal platform hash reference.
 *
 * @property {Object} appletv
 * @property {Object} chromecast
 * @property {Object} netcast
 * @property {Object} panasonictv
 * @property {Object} orsay
 * @property {Object} sonybravia
 * @property {Object} trilithium
 * @property {Object} tivo
 * @property {Object} tizen
 * @property {Object} vizio
 * @property {Object} webos
 *
 */

/**
 *
 * @type {SDK.Services.Configuration.PlatformProfileReference}
 *
 */
export default {
    appletv: {
        deviceProfile: 'apple',
        applicationRuntime: 'appletv'
    },
    chromecast: {
        deviceProfile: 'google',
        applicationRuntime: 'chromecast'
    },
    netcast: {
        deviceProfile: 'lg',
        applicationRuntime: 'netcast'
    },
    panasonictv: {
        deviceProfile: 'panasonic',
        applicationRuntime: 'panasonictv'
    },
    orsay: {
        deviceProfile: 'samsung',
        applicationRuntime: 'orsay'
    },
    sonybravia: {
        deviceProfile: 'sony',
        applicationRuntime: 'sonybravia'
    },
    trilithium: {
        deviceProfile: 'sony',
        applicationRuntime: 'trilithium'
    },
    tivo: {
        deviceProfile: 'tivo',
        applicationRuntime: 'tivo'
    },
    tizen: {
        deviceProfile: 'samsung',
        applicationRuntime: 'tizen'
    },
    vizio: {
        deviceProfile: 'vizio',
        applicationRuntime: 'vizio'
    },
    webos: {
        deviceProfile: 'lg',
        applicationRuntime: 'webos'
    }
};



// WEBPACK FOOTER //
// ./src/services/configuration/platformProfileReference.js